module.exports = __webpack_public_path__ + "static/monthly_challenges_screen-3c0438d430c6d0324e127cdea3f249fa.png";